/**
 * Advisor ツール結果の型定義とユーティリティ
 *
 * desktop-app / web の両パッケージで共通利用する。
 */
export function isAdvisorResult(result) {
    if (!result || typeof result !== 'object')
        return false;
    const r = result;
    return r.status === 'success' || r.status === 'error' || r.status === 'limit_reached';
}
/**
 * Advisor ツール呼び出しの引数から相談内容（question）を取り出す。
 * question 引数の追加前に記録された呼び出し（引数 `{}`）では undefined を返す。
 */
export function getAdvisorQuestion(args) {
    let value = args;
    if (typeof value === 'string') {
        try {
            value = JSON.parse(value);
        }
        catch {
            return undefined;
        }
    }
    if (!value || typeof value !== 'object')
        return undefined;
    const question = value.question;
    if (typeof question !== 'string')
        return undefined;
    return question.trim() || undefined;
}
//# sourceMappingURL=advisor-result.js.map